import { observer } from 'mobx-react-lite';
import { AppProps } from './App';
import { loadNewMbox } from '../stores/appStateStore';
import { runInAction } from 'mobx';

const LandingPage = observer((props: AppProps) => {
    const { state } = props;

    return (<div id="landingPage" className="flex-mother fill">
        <div className="flex-1" />
        <div className="flex-mother-col" >
            <div className="info-panel">
                <div className="info-panel-content">
                    <div style={{ flex: '1 1 30%' }}>
                        <img src="./logo512.png" height={300} />
                    </div>
                    <div style={{ flex: '2 1 70%' }}>
                        <h2 className="secondary-text">Welcome to the GoldFynch Mbox Viewer</h2>
                        <div className="upload-container mt-10px text-center">
                            <h4>To get started, drag an Mbox file to this browser window, or click below to select one.</h4>
                            <div>
                                <input
                                    id="fileUploadButton"
                                    className="hidden"
                                    type="file"
                                    accept=".mbox"
                                    multiple
                                    onChange={async e => {
                                        if (e.target.files) {
                                            for (let i = 0; i < e.target.files.length; i++) {
                                                loadNewMbox(state, e.target.files[i]).then((newMbox) => {
                                                    if (newMbox) {
                                                        runInAction(() => {
                                                            state.mboxList.push(newMbox);
                                                        });
                                                    }
                                                });
                                            }
                                        }
                                    }}
                                />

                                <div className="flex-mother">
                                    <div className="flex-1" />
                                    <button className="rectangular-btn text-bold" onClick={e => { document.getElementById('fileUploadButton')?.click(); }}>OPEN AN MBOX FILE</button>
                                    <div className="flex-1" />
                                </div>

                            </div>

                        </div>
                        <div className="text-14px ">
                            <div className="mt-20px">This app will let you quickly view the contents of an Mbox email archive.</div>
                            <div className="mt-20px">No file data or metadata is sent to our servers.</div>
                            <div>All of the processing is done by your machine in the web browser.</div>
                            <div>After opening the page it can be run offline. <a className="landing-page-link no-decoration" href='https://goldfynch.com/goldfynch-mbox-viewer.html'>Learn more {'>>'}</a></div>
                            <div className="mt-20px">For questions or comments, please email <a className="landing-page-link no-decoration" href="mailto:support@goldfynch.com">support@goldfynch.com</a>.</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="pst-section text-bold text-center mt-50px text-14px">
                <p>Need to view a PST/OST file? Try our free browser-based <a href="https://goldfynch.com/goldfynch-pst-viewer" className="landing-page-link no-decoration">PST Viewer.</a></p>
                <p>Or scan corrupt PSTs / PSTs with errors for a detailed report with our free <a href="https://goldfynch.com/goldfynch-pst-analyzer" className="landing-page-link no-decoration">PST Analyzer.</a></p>
                <p>No download required.</p>
            </div>
            <div className="ediscovery-section text-bold text-center mt-50px text-14px">
                <p>Do more with your MBOX/PST/OST files!</p>
                <p>Convert to PDFs, search, review, redact, annotate, produce and share with GoldFynch eDiscovery.</p>
                <a className="text-bold yellow-link text-18px" href="https://goldfynch.com">Try for free now!</a>
            </div>
            <div className="mt-50px text-center">
                <a className="landing-page-link text-bold" href='https://www.ediscoverytoolkit.com'>Check out GoldFynch’s other Free Tools</a>
            </div>
            {state.showBanner && 
                <a href='https://goldfynch.com/app/signup'>
                    <div className="gf-banner">
                    <span
                        onClick={(event) => {
                            event.preventDefault();
                            
                            runInAction(() => {
                                state.showBanner = false;
                            });
                        }} className="close">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M6 18L18 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </span>
                    </div>
                </a>
            }
            <div className="flex-1" />
            <div className="mt-150px text-center text-11px">
                <p>Copyright © 2025, Mazira, LLC, the creators of GoldFynch</p>
                <p>End User License Agreement</p>
            </div>
        </div>
        <div className="flex-1" />
    </div>);
});

export default LandingPage;
